import Guid from "common/values/guid/guid";
import { OrderDirection } from "common/contracts/order-direction";
import PaginationParameters from "common/contracts/pagination-parameters";

export enum CreatorType
{
    Client,
    Vendor
}

export class WorkTeamTemplateFilterParameters {
    entityId: Guid;
    name?: string;
    leader?: string;
    member?: string;
    company?: string;
    creatorType?: CreatorType;
    query?: string;
    isArchived?: boolean;

    constructor(
        entityId: Guid,
        name?: string,
        leader?: string,
        member?: string,
        company?: string,
        creatorType: CreatorType = CreatorType.Client,
        query?: string,
        isArchived: boolean = false
    ) {
        this.entityId = entityId;
        this.name = name;
        this.leader = leader;
        this.member = member;
        this.company = company;
        this.creatorType = creatorType;
        this.query = query;
        this.isArchived = isArchived;
    }

    public asSearchParams(): URLSearchParams {
        const searchParams = new URLSearchParams();
        if (this.entityId) searchParams.append("entityId", this.entityId.toString());
        if (this.name) searchParams.append("name", this.name);
        if (this.leader) searchParams.append("leader", this.leader);
        if (this.member) searchParams.append("member", this.member);
        if (this.company) searchParams.append("company", this.company);
        if (this.creatorType) searchParams.append("creatorType", this.creatorType.toString());
        else searchParams.append("creatorType", CreatorType.Client.toString());
        if (this.query) searchParams.append("query", this.query);
        if (this.isArchived === true) searchParams.append("isArchived", "true");
        else searchParams.append("isArchived", "false");
        return searchParams;
    }

    public isEqualTo(other: WorkTeamTemplateFilterParameters): boolean {
        if (!other) return false;
        return this.entityId.isEqualTo(other.entityId) &&
            this.name === other.name &&
            this.leader === other.leader &&
            this.member === other.member &&
            this.company === other.company &&
            this.creatorType === other.creatorType &&
            this.query === other.query &&
            this.isArchived === other.isArchived;
    }
}

export enum WorkTeamTemplateOrderField {
    Name = "Name",
    Leader = "Leader",
    Member = "Member",
    Company = "Company"
}

export class WorkTeamTemplateOrderParameters {
    orderBy?: WorkTeamTemplateOrderField;
    orderDir?: OrderDirection; 

    constructor(
        orderBy: WorkTeamTemplateOrderField = WorkTeamTemplateOrderField.Name,
        orderDir: OrderDirection = OrderDirection.Ascending
    ) {
        this.orderBy = orderBy;
        this.orderDir = orderDir;
    }

    public asSearchParams(): URLSearchParams {
        const searchParams = new URLSearchParams();
        if (this.orderBy) searchParams.append("orderBy", this.orderBy);
        if (this.orderDir) searchParams.append("orderDir", this.orderDir);
        return searchParams;
    }

    public isEqualTo(other: WorkTeamTemplateOrderParameters): boolean {
        if (!other) return false;
        return this.orderBy === other.orderBy && this.orderDir === other.orderDir;
    }
}

export default class WorkTeamTemplateQuery {
    filterParameters: WorkTeamTemplateFilterParameters;
    orderParameters: WorkTeamTemplateOrderParameters;
    paginationParameters: PaginationParameters;

    constructor(
        filterParameters: WorkTeamTemplateFilterParameters,
        orderParameters: WorkTeamTemplateOrderParameters,
        paginationParameters: PaginationParameters
    ) {
        this.filterParameters = filterParameters;
        this.orderParameters = orderParameters;
        this.paginationParameters = paginationParameters;
    }

    public asSearchParams(): URLSearchParams {
        return new URLSearchParams([
            ...this.paginationParameters.asSearchParams(),
            ...this.orderParameters.asSearchParams(),
            ...this.filterParameters.asSearchParams()
        ]);
    }

    isEqualTo(other: WorkTeamTemplateQuery): boolean {
        if (!other) {
            return false;
        }
        return this.filterParameters.isEqualTo((other.filterParameters)) &&
            this.orderParameters.isEqualTo((other.orderParameters)) &&
            this.paginationParameters.isEqualTo((other.paginationParameters));
    }
}